var EXCLUDED_PERSONA_MAILBOX_TYPES = ['GroupMailbox', 'PrivateDL', 'PublicDL'];
export function doesSubjectPickerSupportPersona(persona) {
    return (persona.EmailAddress &&
        persona.EmailAddress.EmailAddress &&
        !EXCLUDED_PERSONA_MAILBOX_TYPES.includes(persona.EmailAddress.MailboxType));
}
//# sourceMappingURL=doesSubjectPickerSupportPersona.js.map